import { createActions, createReducer } from 'reduxsauce'

import TipoServicoService from '../servicos/TipoServicoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaTipoServicoInicio: [],
    buscaTipoServicoSucesso: ['tipoServico'],
    buscaTipoServicoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaTipoServico = () => {
    return dispatch => {
        dispatch(Creators.buscaTipoServicoInicio())
        let serv = new TipoServicoService()
        return serv
            .getTipoServicos()
            .then(response => dispatch(Creators.buscaTipoServicoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaTipoServicoErro(error)))
    }
}

const buscaTipoServicoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaTipoServicoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaTipoServicoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.tipoServico, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_TIPO_SERVICO_INICIO]: buscaTipoServicoInicio,
    [Types.BUSCA_TIPO_SERVICO_ERRO]: buscaTipoServicoErro,
    [Types.BUSCA_TIPO_SERVICO_SUCESSO]: buscaTipoServicoSucesso,
})
